import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Custom,
  Textbox
} from '@app/shared';

@Injectable()
export class ManagementGroupsProcessFormsService {
  constructor() { }

  /**
   * Retorna el formulario de asociacion de rol(Grupo) a un tramite
   *
   * @param {*} templetesFomr
   * @param {*} options
   * @returns {BaseControl<any>[]}
   * @memberof ManagementGroupsProcessFormsService
   */
  getFormRol(templetesFomr: any, options: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboGroup',
        label: 'Grupo',
        order: 1,
        template: templetesFomr,
        placeholder: 'Seleccione el grupo',
        value: null,
        options: options ? options : [],
        validations: {
          validators: [Validators.required]
        },
      }),
      new Textbox({
        key: 'chInicia',
        type: 'checkbox',
        value: false,
        label: 'Inicia',
        order: 2,
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-groups-process/shared/management-groups-process.form.service.ts